import { createContext } from 'react';

const ElectronContext = createContext({});

export default ElectronContext;